"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            email: null,
            action: null,
            submitting: false
        };
        GState.bind(this, ['tenant']);
        fhandler.bind(this);
    },
    onInput: function (input) {
        (!input.params.pros || !input.params.vuid) && navigate('/');
        this.state.email = input.params.vuid;
        this.state.action = input.params.pros;
    },
    onSubmitPhoneNumber: async function (type) {
        if (this.state.submitting)
            return;
        if (!this.state.form.phone)
            return this.state.formError.phone;
        const Form = {
            email: this.input.params.vuid,
            factor: {
                type: 'code',
                phone: this.state.form.phone
            }
        };
        this.state.submitting = true;
        try {
            const {error, message, token} = await AuthRequest('/two-step/enable', 'PATCH', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'info' : 'success');
            if (error)
                return;
            !error && fhandler.reset();
            window.uiStore.set('2FA-Factor', Form.factor);
            navigate(`/two-step/verify?mtd=code&vtoken=${ token }&${ this.createQueries() }`);
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error, 'warning');
        }
    },
    onAdd: function () {
        this.state.action = 'code';
    },
    onCancel: function () {
        this.state.action = this.input.params.pros;
    },
    onPhoneError: function (errmess) {
        fhandler.error('phone', errmess);
    },
    createQueries: function () {
        const {ctoken, deviceId, type, role} = this.input.params;
        if (!ctoken || !deviceId || !type || !role)
            return navigate('/signout');
        let queries = Obj2Params({
            ctoken,
            deviceId,
            type,
            role
        });
        if (isDefaultDomain())
            queries += '&redirectTo=/onboarding';
        else {
            if (this.input.params.hasOwnProperty('redirectTo'))
                queries += '&redirectTo=' + encodeURIComponent(this.input.params.redirectTo);
        }
        return queries;
    },
    grantAccess: function () {
        document.location = `/authorize?${ this.createQueries() }`;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Auth/TwoStep.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    TenantLogo_template = require("../../../components/TenantLogo/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    TenantLogo_tag = marko_loadTag(TenantLogo_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Image_template = require("../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    IntlTelInput_template = require("marko-intl-tel-input/index.marko"),
    IntlTelInput_tag = marko_loadTag(IntlTelInput_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    AuthLayout_template = require("../../components/AuthLayout/index.marko"),
    AuthLayout_tag = marko_loadTag(AuthLayout_template),
    marko_attrs0 = {
        "class": "card-header w-100 pb-0"
      },
    marko_attrs1 = {
        "class": "card-body"
      },
    marko_attrs2 = {
        "class": "text-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("ac46b6"),
    marko_node0 = marko_createElement("br", null, "11", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "font-medium-2"
      },
    marko_attrs4 = {
        href: "/"
      },
    marko_node2 = marko_createElement("br", null, "17", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "py-1"
      },
    marko_attrs6 = {
        "class": "btn btn-outline-primary btn-xl px-3"
      },
    marko_attrs7 = {
        "class": "btn btn-primary btn-xl text-left float-right w-50"
      },
    marko_attrs8 = {
        "class": "col-3"
      },
    marko_attrs9 = {
        "class": "col text-right"
      },
    marko_attrs10 = {
        "class": "font-medium-5"
      },
    marko_attrs11 = {
        "class": "card-header w-100 pb-0"
      },
    marko_attrs12 = {
        "class": "card-body"
      },
    marko_attrs13 = {
        "class": "text-center"
      },
    marko_node3 = marko_createElement("br", null, "34", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "35", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs14 = {
        "class": "font-medium-2"
      },
    marko_attrs15 = {
        href: "/"
      },
    marko_node5 = marko_createElement("br", null, "41", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs16 = {
        "class": "animated fast fadeIn"
      },
    marko_attrs17 = {
        "class": "form-group"
      },
    marko_node6 = marko_createElement("br", null, "47", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs18 = {
        "class": "py-1"
      },
    marko_attrs19 = {
        "class": "btn btn-outline-primary btn-xl px-3",
        type: "reset"
      },
    marko_attrs20 = {
        "class": "col-3"
      },
    marko_attrs21 = {
        "class": "col text-right"
      },
    marko_attrs22 = {
        "class": "font-medium-5"
      },
    marko_attrs23 = {
        "class": "font-small-4"
      };

const fhandler = new FormHandler({ key: 'add-phone-form' });

function render(input, out, __component, component, state) {
  var data = input;

  AuthLayout_tag({
      renderBody: function(out) {
        if (state.action == "suggest") {
          out.be("div", marko_attrs0, "1", component);

          Row_tag({
              class: "d-flex align-items-center",
              renderBody: function(out) {
                out.be("div", marko_attrs8, "3", component);

                TenantLogo_tag({
                    style: "width:40px"
                  }, out, __component, "4");

                out.ee();

                out.be("div", marko_attrs9, "5", component);

                out.be("h4", marko_attrs10, "6", component);

                Locale_tag({
                    text: "Protect your account"
                  }, out, __component, "7");

                out.ee();

                out.ee();
              }
            }, out, __component, "2");

          out.ee();

          out.be("div", marko_attrs1, "8", component);

          out.be("div", marko_attrs2, "9", component);

          Image_tag({
              alt: "Image",
              src: "/images/illustration/2-step-auth.jpg",
              class: "img-fluid w-75"
            }, out, __component, "10");

          out.ee();

          out.n(marko_node0, component);

          out.n(marko_node1, component);

          out.be("p", marko_attrs3, "13", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Add a 2-step verification to your account for more security and get notified anytime there's unsual activity on your account.");
              }
            }, out, __component, "14");

          out.be("a", marko_attrs4, "15", component);

          Locale_tag({
              text: "Learn more"
            }, out, __component, "16");

          out.ee();

          out.ee();

          out.n(marko_node2, component);

          out.be("div", marko_attrs5, "18", component);

          out.be("button", marko_attrs6, "19", component, null, 0, {
              onclick: __component.d("click", "grantAccess", false)
            });

          Locale_tag({
              text: "Not now"
            }, out, __component, "20");

          out.ee();

          out.be("button", marko_attrs7, "21", component, null, 0, {
              onclick: __component.d("click", "onAdd", false)
            });

          Bx_tag({
              type: "right-arrow-alt",
              class: "font-large-1 float-right white-text"
            }, out, __component, "22");

          Locale_tag({
              text: "Add"
            }, out, __component, "23");

          out.ee();

          out.ee();

          out.ee();
        }

        if (state.action == "code") {
          out.be("div", marko_attrs11, "24", component);

          Row_tag({
              class: "d-flex align-items-center",
              renderBody: function(out) {
                out.be("div", marko_attrs20, "26", component);

                TenantLogo_tag({
                    style: "width:40px"
                  }, out, __component, "27");

                out.ee();

                out.be("div", marko_attrs21, "28", component);

                out.be("h4", marko_attrs22, "29", component);

                Locale_tag({
                    text: "Enable 2-Step Verification"
                  }, out, __component, "30");

                out.ee();

                out.ee();
              }
            }, out, __component, "25");

          out.ee();

          out.be("div", marko_attrs12, "31", component);

          out.be("form", null, "@add-phone-form", component);

          out.be("div", marko_attrs13, "32", component);

          Image_tag({
              alt: "Image",
              src: "/images/illustration/2-step code-verification.png",
              class: "img-fluid w-50"
            }, out, __component, "33");

          out.ee();

          out.n(marko_node3, component);

          out.n(marko_node4, component);

          out.be("p", marko_attrs14, "36", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Get a verification code via SMS or a call on your phone number.");
              }
            }, out, __component, "37");

          out.t(" ");

          out.be("a", marko_attrs15, "38", component);

          Locale_tag({
              text: "Learn more"
            }, out, __component, "39");

          out.ee();

          out.ee();

          FormAlert_tag({
              alert: state.alert,
              class: "mx-50"
            }, out, __component, "40");

          out.n(marko_node5, component);

          out.be("div", marko_attrs16, "42", component);

          out.be("div", marko_attrs17, "43", component);

          IntlTelInput_tag({
              value: state.form.phone,
              name: "phone",
              E123: true,
              class: "form-control-xl",
              pattern: fhandler.define("required phone"),
              __events: [
                "on",
                "change",
                "on",
                "error"
              ]
            }, out, __component, "44", [
            [
              "change",
              "__onChange",
              false
            ],
            [
              "error",
              "onPhoneError",
              false
            ]
          ]);

          if (state.formError.phone) {
            out.be("p", marko_attrs23, "45", component);

            Locale_tag({
                text: state.formError.phone
              }, out, __component, "46");

            out.ee();
          }

          out.ee();

          out.ee();

          out.n(marko_node6, component);

          out.be("div", marko_attrs18, "48", component);

          out.be("button", marko_attrs19, "49", component, null, 0, {
              onclick: __component.d("click", "onCancel", false)
            });

          Locale_tag({
              text: "Cancel"
            }, out, __component, "50");

          out.ee();

          out.be("button", {
              type: "submit",
              disabled: (!state.form.phone) || state.submitting,
              "class": "btn btn-primary btn-xl text-left float-right w-50"
            }, "51", component, null, 0, {
              onclick: __component.d("click", "onSubmitPhoneNumber", false)
            });

          if (state.submitting) {
            Preloader_tag({
                class: "float-right font-medium-5",
                active: true
              }, out, __component, "52");
          } else {
            Bx_tag({
                type: "right-arrow-alt",
                class: "font-large-1 float-right white-text"
              }, out, __component, "53");
          }

          Locale_tag({
              text: "Continue"
            }, out, __component, "54");

          out.ee();

          out.ee();

          out.ee();

          out.ee();
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
